import { render, staticRenderFns } from "./DetailsMaterialsComputation.vue?vue&type=template&id=db7c0a2e&scoped=true&"
import script from "./DetailsMaterialsComputation.vue?vue&type=script&lang=js&"
export * from "./DetailsMaterialsComputation.vue?vue&type=script&lang=js&"
import style0 from "./DetailsMaterialsComputation.vue?vue&type=style&index=0&id=db7c0a2e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7c0a2e",
  null
  
)

export default component.exports